export const stringToUndefinedIfEmpty = (
  name: string | undefined
): string | undefined => {
  return name?.trim() ? name : undefined;
};
